import React from 'react';
import { strings } from '../../constants/localization';

interface Step4Props {
    currentStep: number;
    location: string;
    address: string;
    zipCode: string;
    city: string;
    phone: string;
    cvr: string;
    email: string;
    registrationNo: string;
    accountNo: string;
    website: string;
    hideLocation: boolean;
    createNewUserHandler: () => void;
}

const Step4: React.FC<Step4Props> = ({ currentStep, location, address, zipCode, city, phone, cvr, email, accountNo, registrationNo, website, hideLocation, createNewUserHandler }) => {

    if (currentStep !== 4) {
        return null;
    } else {
        return (
            <div className='step step4'>
                <div className='icon'>
                    <i className='lnil lnil-checkmark-circle' />
                </div>
                <div className='title'>{strings.locationFlow_step4_title}</div>
                <div className='description'>
                    {strings.formatString(
                        strings.locationFlow_step4_description,
                        location,
                    )}
                </div>

                <div className='formWrapper'>
                    <div className='locationData'>
                        <div className='name'>{location}</div>

                        <div className='line'>
                            {/* Address */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='lnil lnil-house-alt' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>
                                        {strings.locationFlow_step4_adress}
                                    </div>
                                    <div
                                        className={`value ${address ? 'hasValue' : 'empty'}`}
                                    >
                                        {!address
                                            ? strings.locationFlow_step4_notSet
                                            : `${address}\n${zipCode} ${city}`}
                                    </div>
                                </div>
                            </div>
                            {/* Telephone */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='di di-phone' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>
                                        {strings.locationFlow_step4_phone}
                                    </div>
                                    <div
                                        className={`value ${phone ? 'hasValue' : 'empty'}`}
                                    >
                                        {!phone ? strings.locationFlow_step4_notSet : phone}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='line'>
                            {/* CVR */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='lnil lnil-shield' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>{strings.locationFlow_step4_cvr}</div>
                                    <div className={`value ${cvr ? 'hasValue' : 'empty'}`}>
                                        {!cvr ? strings.locationFlow_step4_notSet : cvr}
                                    </div>
                                </div>
                            </div>
                            {/* Email */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='lnil lnil-envelope' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>
                                        {strings.locationFlow_step4_email}
                                    </div>
                                    <div
                                        className={`value ${email ? 'hasValue' : 'empty'}`}
                                    >
                                        {!email ? strings.locationFlow_step4_notSet : email}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='line'>
                            {/* Registration no */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='lnil lnil-bank' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>
                                        {strings.locationFlow_step4_accountNo}
                                    </div>
                                    <div
                                        className={`value ${registrationNo && accountNo ? 'hasValue' : 'empty'
                                            }`}
                                    >
                                        {!registrationNo && !accountNo
                                            ? strings.locationFlow_step4_notSet
                                            : `${registrationNo} ${accountNo}`}
                                    </div>
                                </div>
                            </div>
                            {/* Webiste */}
                            <div className='column'>
                                <div className='icon'>
                                    <i className='lnil lnil-link' />
                                </div>
                                <div className='input_details'>
                                    <div className='label'>{strings.locationFlow_step4_web}</div>
                                    <div
                                        className={`value ${website ? 'hasValue' : 'empty'}`}
                                    >
                                        {!website
                                            ? strings.locationFlow_step4_notSet
                                            : website}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* This line should only be shown if showInIndex is "true". */}
                    {hideLocation && (
                        <div className='more_info'>
                            <i className='lnir lnir-alarm-clock' />
                            {strings.locationFlow_step4_visible}
                        </div>
                    )}

                    <div className='link_zone'>
                        {strings.locationFlow_step4_Manager}
                        <span className='step_link'
                            onClick={() => {
                                createNewUserHandler();
                            }}
                        >
                            {strings.locationFlow_step4_createUser}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
};

export default Step4;